import { createRouter, createWebHistory } from "vue-router";
import pagenot from "../components/pageNot.vue";
import flightInfo from "../components/flightInfo.vue";
import confirmBook from "../components/confirmBook.vue";
import bookingCofirm from "../components/bookingCofirm.vue";
import hello from "../components/homeComponent.vue";
import search from "../components/SearchResult.vue";
import loader from "../components/loaderComponent.vue";
import test from "@/components/testCom.vue";
import termUse from "@/components/termUse.vue";
import aboutUs from "@/components/aboutUs.vue";
import privacyPolicy from "@/components/privacyPolicy.vue";
import contactPage from "@/components/contactPage.vue";
import pageError from "@/components/pageError.vue";
import dashBoard from "@/components/dashBoard.vue";
import viewBooking from "@/components/viewBooking.vue";
import dataloader from "@/components/dataLoder.vue";
import newPassword from "@/components/newPassword.vue";
import bookingView from "@/components/bookingView.vue";
import login from "../components/loginCom.vue";
import register from "../components/registerCom.vue";
import myBooking from "../components/myBooking.vue";
import myprofile from "@/components/myProfile.vue";

const routes = [
  {
    path: "/",
    component: hello,
  },
  {
    path: "/flight/search",
    component: search,
  },

  {
    path: "/test",
    component: test,
  },
  {
    path: "/termUse",
    component: termUse,
  },
  {
    path: "/pageNot",
    component: pagenot,
  },
  {
    path: "/dataloader",
    component: dataloader,
  },
  {
    path: "/loader",
    component: loader,
  },
  {
    path: "/flightInfo",
    component: flightInfo,
  },
  {
    path: "/confirmBook",
    component: confirmBook,
  },
  {
    path: "/bookingCofirm",
    component: bookingCofirm,
  },
  {
    path: "/aboutUs",
    component: aboutUs,
  },
  {
    path: "/page/privacy-policy",
    component: privacyPolicy,
  },
  {
    path: "/contactPage",
    component: contactPage,
  },
  {
    path: "/pageError",
    component: pageError,
  },
  {
    path: "/dashboard",
    component: dashBoard,
  },
  {
    path: "/viewbooking",
    component: viewBooking,
  },
  {
    path: "/newPassword",
    component: newPassword,
  },
  {
    path: "/bookingView",
    component: bookingView,
  },
  {
    path: "/login",
    component: login,
  },
  {
    path: "/register",
    component: register,
  },
  {
    path: "/mybooking",
    component: myBooking,
  },
  {
    path: "/myprofile",
    component: myprofile,
  },

  { path: "/:pathMatch(.*)*", name: "NotFound", component: pagenot },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
